<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraAgente />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraAgente from "../Components/Leituras/LeituraAgente.vue";
export default {
  name: "ReadReserve",
  components: {
    LeituraAgente,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>